import { COLORS } from '@/components/common/Activities/ActivityMenu/styles/constants';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const Pill = styled.button<{ $active: boolean }>`
  padding: 0.5rem 1rem;
  border-radius: 16px;
  border: 1px solid ${COLORS.BORDER_LIGHT};
  background: ${({ $active }) =>
    $active ? COLORS.PRIMARY : COLORS.BACKGROUND};
  color: ${({ $active }) => ($active ? COLORS.BACKGROUND_PRIMARY : 'inherit')};
  cursor: pointer;
`;

export const ErrorText = styled.p`
  color: ${COLORS.ERROR};
  font-size: 0.875rem;
`;
